import React from "react";
import { StatusNotificationScreen } from "../../common/StatusNotificationScreen";
import { createApi } from "../../utils/createApi";
import {
  OnboardingProgressDiv,
  isCameraCheckSupported,
} from "../Onboarding/OnboardingProgressDiv";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../utils/universalAPIErrorHandler";
import { NavigateFunction } from "react-router-dom";
import { AddWebhookScreen, AddWebhookFormValues } from "./AddWebhookScreen";
import { extractWebhookFieldErrors } from "../../utils/webhookAuth";
import { fetchAddCameraInfo } from "../Sites/SitesPage/SitesPageUtils/fetchAddCameraInfo";
import { handleAddImmixToAddCameraForm } from "./handleAddImmixToAddCameraForm";
import { handleAddDiceToAddCameraForm } from "./handleAddDiceToAddCameraForm";

export const handleSubmitWebhooks = (
  webhooksInfo: any,
  setVisibleScreen: any,
  navigate: NavigateFunction,
  formValues?: AddWebhookFormValues
) => {
  setVisibleScreen(
    <StatusNotificationScreen
      styling="absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80"
      text={
        <p>
          Submitting Webhooks info.
          <br />
          This might take a few seconds.
        </p>
      }
    />
  );
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    handleSubmitWebhooks(webhooksInfo, setVisibleScreen, navigate, formValues);
  };
  AxiosUI.post("webhook_customer/", {
    ...webhooksInfo,
    customer: Number(localStorage.siteId),
  }).then(
    () => {
      AxiosUI.get(
        `customer/${Number(localStorage.siteId)}/camera_onboarding_forms/`
      ).then(
        (response: AxiosResponse) => {
          // handleAddImmixToAddCameraForm(response.data);
          // handleAddDiceToAddCameraForm(response.data);
          localStorage.setItem("addCameraInfo", JSON.stringify(response.data));
          localStorage.setItem(
            "selectedProducts",
            JSON.stringify(response.data.initial_data.products)
          );
        },
        (reason: AxiosError) => {
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {
            setVisibleScreen(
              <StatusNotificationScreen
                styling="absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80"
                text="Webhooks setup successful!"
              />
            );
            setTimeout(() => {
              setVisibleScreen(
                <OnboardingProgressDiv
                  percentage={
                    isCameraCheckSupported()
                      ? localStorage.healthMonitoringOnly === "true"
                        ? 33
                        : 25
                      : 33
                  }
                  step={1}
                  setVisibleScreen={setVisibleScreen}
                />
              );
            }, 2000);
          });
        }
      );
      setVisibleScreen(
        <StatusNotificationScreen
          styling="absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80"
          text="Webhooks setup successful!"
        />
      );
      setTimeout(() => {
        setVisibleScreen(
          <OnboardingProgressDiv
            percentage={
              isCameraCheckSupported()
                ? localStorage.healthMonitoringOnly === "true"
                  ? 33
                  : 25
                : 33
            }
            step={1}
            setVisibleScreen={setVisibleScreen}
          />
        );
      }, 2000);
    },
    (reason: AxiosError) => {
      // A 400 names the rejected fields (e.g. an auth_endpoint refused by the
      // SSRF guard, an auth_body that can't authenticate): put the form back
      // with the user's input and the messages inline on those fields.
      const fieldErrors = extractWebhookFieldErrors(reason);
      if (Object.keys(fieldErrors).length > 0) {
        setVisibleScreen(
          <AddWebhookScreen
            setVisibleScreen={setVisibleScreen}
            siteId={webhooksInfo.customer}
            initialValues={formValues}
            fieldErrors={fieldErrors}
          />
        );
        return;
      }
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        alert("Error submitting Webhooks info. Please try again.");
        setVisibleScreen(
          <AddWebhookScreen
            setVisibleScreen={setVisibleScreen}
            siteId={webhooksInfo.customer}
            initialValues={formValues}
          />
        );
      });
    }
  );
};
